import React from 'react';
import logoYachtValues from "@/assets/yacht-values-logo-new.png";

export default function Logo() {
  return (
    <div className="flex items-center justify-center">
      <img 
        src={logoYachtValues} 
        alt="YachtValues instant yacht valuation and market intelligence logo" 
        className="h-24 w-auto"
        width="320"
        height="206"
        style={{ maxWidth: '320px' }}
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </div>
  );
}
